import { ColoursObj } from '@eventr/common-storybook'
import { ExpandLess } from '@mui/icons-material'

interface IExpandProps {
    expanded: boolean
    past?: boolean
    colour?: string
}
export const Expand = ({
    expanded,
    past,
    colour = ColoursObj.core.primary,
}: IExpandProps) => {
    return (
        <>
            {expanded ? (
                <ExpandLess
                    sx={{
                        color: `${past ? ColoursObj.shades.shade2 : colour}`,
                        transition: 'ease 0.3s',
                    }}
                />
            ) : (
                <ExpandLess
                    sx={{
                        color: `${past ? ColoursObj.shades.shade2 : colour}`,
                        transition: 'ease 0.3s',
                        transform: 'ScaleY(-1)',
                    }}
                />
            )}
        </>
    )
}
